module.exports = __webpack_public_path__ + "img/流程设计_04.86318b59.svg";